import IxAddress from 'vue-src/classes/ix-address'
import {debugLog} from "vue-src/utils"
import {IxFetch, IxApi, IxPatch} from "vue-src/IxPlugin/api"
import Vue from 'vue'


let state = function () {
  let data = Object.assign({
    refreshed: false,
    userData: {},
    addresses: [],
    addressesCount: 0,
    addressesPage:1,
    addressesLoading: 0,
    // Bill To
    billToAddresses: [],
    billToCount: 0,
    billToPage: 1,
    billToLoading: 0,
    billToSearch:'',
    // Ship To
    shipToAddresses: [],
    shipToCount: 0,
    shipToPage: 1,
    shipToLoading: 0,
    shipToSearch: '',
  }, window.ix_token)
  return data
}

const getters = {
  getTokenString(state) {
    return state.token_type + ' ' + state.access_token
  },
  authRefreshed(state) {
    return state.refreshed
  },
  isLoggedIn(state) {
    return state.loggedIn
  },
  getUserData(state) {
    return state.userData
  },
  poRequired(state, getters) {
    if (state.loggedIn) {
      return getters.storeConfig.purchase_order_required ||
        (state.userData.customer_info && state.userData.customer_info.purchase_order_required)
    }
    return getters.storeConfig.guest_purchase_order_required
  },
  checkoutCaptchaRequired(state, getters) {
    return getters.storeConfig.checkout_captcha_required
  },
  getUserAddresses(state) {
    return state.addresses
  },
  getCustomerAddress(state) {
    return state.addresses.filter(e => e.address_type === 'customer')[0]
  },
  getShipToAddresses(state) {
    return state.addresses.filter(e => e.address_type === 'shipto' || e.address_type === 'customer')
  },
  getBillToAddresses(state) {
    return state.addresses.filter(e => e.address_type === 'billto' || e.address_type === 'customer')
  },
  getDefaultShipToAddress(state, getters) {
    let addresses = []
    if(state.userData.default_shipping_address){
      addresses = getters.getShipToAddresses.filter(e => e.url === state.userData.default_shipping_address)
    }
    if(addresses.length === 0){
      addresses = getters.getShipToAddresses.filter(e => e.default && e.address_type ==='shipto')
    }
    return addresses.length > 0 ? addresses[0] : getters.getCustomerAddress
  },
  getDefaultBillToAddress(state, getters) {
    let addresses = []
    if(state.userData.default_billing_address){
      addresses = getters.getBillToAddresses.filter(e => e.url === state.userData.default_billing_address)
    }
    if(addresses.length === 0){
      addresses = getters.getBillToAddresses.filter(e => e.default && e.address_type ==='billto')
    }
    return addresses.length > 0 ? addresses[0] : getters.getCustomerAddress
  },
  getMyAccountDefaultShipToAddress(state,getters){
    let addresses = []
    if(state.userData.default_shipping_address){
      addresses = getters.getShipToAddresses.filter(e => e.url === state.userData.default_shipping_address)
    }
    if(addresses.length === 0){
      addresses = getters.getShipToAddresses.filter(e => e.default && e.address_type ==='shipto')
    }
    return addresses.length > 0 ? addresses[0] : getters.getCustomerAddress
  },
  getMyAccountDefaultBillToAddress(state,getters){
    let addresses = []
    if(state.userData.default_billing_address){
      addresses = getters.getBillToAddresses.filter(e => e.url === state.userData.default_billing_address)
    }
    if(addresses.length === 0){
      addresses = getters.getBillToAddresses.filter(e => e.default && e.address_type ==='billto')
    }
    return addresses.length > 0 ? addresses[0] : getters.getCustomerAddress
  },
  billToPageCount(state) {
    if (state.billToCount) return Math.ceil(state.billToCount / 30.0)
    return 0
  },
  shipToPageCount(state) {
    if (state.shipToCount) return Math.ceil(state.shipToCount / 30.0)
    return 0
  },
}

const mutations = {
  updateToken(state, {token_type, access_token}) {
    state.token_type = token_type
    state.access_token = access_token
    state.loggedIn = true
  },
  setAuthRefreshed(state) {
    state.refreshed = true
  },
  setUserData(state, data) {
    state.userData = data
  },
  setBillToAddresses(state, data) {
    if (data instanceof Array) {
      let newAddresses = []
      for (let i in data) {
        newAddresses.push(new IxAddress(data[i]))
      }
      state.billToAddresses = newAddresses
    }
  },
  setBillToCount(state, payload) {
    state.billToCount = payload
  },
  setBillToPage(state, payload) {
    state.billToPage = payload
  },
  setBillToLoading(state, payload) {
    state.billToLoading = payload
  },
  setBillToSearch(state, payload){
    state.billToSearch = payload
  },
  setShipToAddresses(state, data) {
    if (data instanceof Array) {
      let newAddresses = []
      for (let i in data) {
        newAddresses.push(new IxAddress(data[i]))
      }
      state.shipToAddresses = newAddresses
    }
  },
  setShipToCount(state, payload) {
    state.shipToCount = payload
  },
  setShipToPage(state, payload) {
    state.shipToPage = payload
  },
  setShipToLoading(state, payload) {
    state.shipToLoading = payload
  },
  setShipToSearch(state, payload){
    state.shipToSearch = payload
  },
  setUserAddresses(state, data) {
    if (data instanceof Array) {
      let newAddresses = []
      for (let i in data) {
        newAddresses.push(new IxAddress(data[i]))
      }
      state.addresses = newAddresses
    }
  },
  appendAddress(state, data) {
    let newAddress = new IxAddress(data),
        index = state.addresses.length
    state.addresses.push(newAddress)
    Vue.set(state.addresses, index, newAddress)
  }
}


const actions = {
  updateUserData({commit}, data) {
    commit('setUserData', data)
    Raven.setUserContext({
      username: data.username,
      id: data.customer_info ? data.customer_info.customer_number : null,
    })
    return Promise.resolve()
  },
  updateAddresses({commit}) {
    return IxFetch(IxApi.addresses)
        .then(response => {
          commit('setUserAddresses', response.data.results);
          return Promise.resolve(response);
        })

  },
  async fetchDefaultAddresses({commit}) {
    try{
      let response = await IxFetch(IxApi.addresses, {default:true})
      if(response.status === 200){
        commit('setUserAddresses', response.data.results);
      }
    }catch(e){

    }

    return true

  },
  appendNewAddress({commit}, address) {
    commit('appendAddress', address)
  },
  initAuth({dispatch, commit, getters}) {

    if (getters.isLoggedIn) {
      debugLog('initAuth', 'Logged in!')
      // This is a hacky way to enforce that a fresh user profile is fetched.
      // When the URL includes a query parameter "nocache" with value "user_profile",
      // a cache control header with a zero-second max age is sent with the request.
      const headers = {}
      const noCache = new URLSearchParams(document.location.search).getAll('nocache')
      if (noCache.indexOf('user_profile') >= 0) {
        headers['Cache-Control'] = 'max-age=0'
      }
      return IxFetch(IxApi.user_profile, {}, headers)
          .then(e => dispatch('handleUserInfo', e))
    }
    Raven.setUserContext({
      username: 'Guest',
      id: -1,
    })
    return Promise.resolve()

  },
  handleUserInfo({dispatch}, response) {
    if (response.status === 200) {
      return dispatch('updateUserData', response.data)
    }
  },
  async fetchBillToPage({commit, state}, page = 1) {
    commit('setBillToLoading', page)
    let params = {page: page, address_type: 'billto'}
    if(state.billToSearch !== ''){
      params.search = state.billToSearch
    }
    try {
      let result = await IxFetch(
          IxApi.addresses,
          params
      )
      if (result.status === 200) {
        commit('setBillToCount', result.data.count)
        commit('setBillToPage', page)
        commit('setBillToAddresses', result.data.results)
      }
    } catch (e) {
      commit('setBillToLoading', 0)
      return false
    }
    commit('setBillToLoading', 0)
    return true
  },
  async fetchShipToPage({commit, state}, page = 1) {
    commit('setShipToLoading', page)
    let params = {page: page, address_type: 'shipto'}
    if(state.shipToSearch !== ''){
      params.search = state.shipToSearch
    }
    try {
      let result = await IxFetch(
          IxApi.addresses,
          params
      )
      if (result.status === 200) {
        commit('setShipToCount', result.data.count)
        commit('setShipToPage', page)
        commit('setShipToAddresses', result.data.results)
      }
    } catch (e) {
      commit('setShipToLoading', 0)
      return false
    }
    commit('setShipToLoading', 0)
    return true
  },
  async patchDefaultBillToAddress({state,commit},url){
    try {
      let payload = {"default_billing_address":url},
          result = await IxPatch(state.userData.url, payload)
      debugLog(payload,result)
      if(result.status === 200){
        commit('setUserData', result.data)
        return true
      }
      return false
    }catch(e){
      console.log(e)
      return false
    }
  },
  async patchDefaultShipToAddress({state,commit},url){
    try {
      let payload = {"default_shipping_address":url},
          result = await IxPatch(state.userData.url, payload)
      debugLog(payload,result)

      if(result.status === 200){
        commit('setUserData', result.data)
        return true
      }
      return false
    }catch(e){
      console.log(e)
      return false
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/store/modules/auth.js